define('adminNotificationsFiltersEditView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'buttonView',
  'selectView',
  'checkboxView',
  'userSelectorView',
  'filtersBannerEditView',
  'template!adminNotificationsFiltersEditView'
], function(
  App,
  Module,
  Backbone,
  _,
  ButtonView,
  SelectView,
  CheckboxView,
  UserSelectorView,
  FiltersBannerEditView,
  Tpl
) {
  'use strict';
  
  Module.exports = FiltersBannerEditView.extend({
    template: Tpl,
    className: 'notifications-filters-edit-view ' + FiltersBannerEditView.prototype.className,
    windowTitle: _.i18n('notifications.filters.edit', 'Edit filters for notifications'),

    ui: _.extend({
      dateFrom: '.body .create-date .date-from',
      dateTo: '.body .create-date .date-to'
    }, FiltersBannerEditView.prototype.ui),

    regions: _.extend({
      refuserpidRegion: '.refuserpid-region'
    }, FiltersBannerEditView.prototype.regions),

    initialize: function() {
      FiltersBannerEditView.prototype.initialize.apply(this, arguments);
      this.tableView = this.options.bannerView.options.tableView;
      this.userPidSecIds = this.model.get('userPidSecIds') ? this.model.get('userPidSecIds').split(',') : [];
    },

    onRender: function() {
      if(this.model.get('dateFrom') !== '')
        this.ui.dateFrom.val(new Date(this.model.get('dateFrom')).toISOString().split('T')[0]);
      if(this.model.get('dateTo') !== '')
        this.ui.dateTo.val(new Date(this.model.get('dateTo')).toISOString().split('T')[0]);

      //----------------
      FiltersBannerEditView.prototype.onRender.apply(this, arguments);
    },

    onShow: function() {
      this.refuserpidView = new CheckboxView({
        title: '',
        text: _.i18n('notifications.to', 'Notification to'),
        tabindex: 19
      });
      this.refuserpidRegion.show(this.refuserpidView);
      this.refuserpidView.on('change', function(value) {
        if(value) {
          var userpids = [];

          var usersCollection = new Backbone.Collection(userpids);
          UserSelectorView.prototype.open({
            users: usersCollection.models,
            multiselect: true,
            onSelected: _.bind(function (user) {
              var deferred = new $.Deferred();

              if(!_.contains(this.userPidSecIds, user.get('secId')))
                this.userPidSecIds.push(user.get('secId'));

              this.getRefuserpidText().done(_.bind(function (text) {
                this.refuserpidView.setText(text);
              }, this));

              deferred.resolve();
              return deferred;
            }, this),
            onUnSelected: _.bind(function (user) {
              var deferred = new $.Deferred();
              this.userPidSecIds = _.without(this.userPidSecIds, user.get('secId'));

              this.getRefuserpidText().done(_.bind(function (text) {
                this.refuserpidView.setText(text);
              }, this));

              deferred.resolve();
              return deferred;
            }, this)
          });
        } else {
          this.userPidSecIds = [];
          this.getRefuserpidText().done(_.bind(function (text) {
            this.refuserpidView.setText(text);
          }, this));
        }

      }, this);

      if(this.userPidSecIds.length > 0)
        this.refuserpidView.setValue(true);
      else
        this.refuserpidView.setValue(false);

      this.getRefuserpidText().done(_.bind(function (text) {
        this.refuserpidView.setText(text);
      }, this));

      //----------------
      FiltersBannerEditView.prototype.onShow.apply(this, arguments);
    },


    onConfirm: function() {
      this.model.set({
        dateFrom: this.ui.dateFrom.val() !== '' ? new Date(this.ui.dateFrom.val()).getTime() : '',
        dateTo: this.ui.dateTo.val() !== '' ? new Date(this.ui.dateTo.val()).getTime() : ''
      });
      this.model.set({userPidSecIds: this.userPidSecIds.join(',')});

      //----------------
      FiltersBannerEditView.prototype.onConfirm.apply(this, arguments);
    },

    onReset: function() {
      this.ui.dateFrom.val('');
      this.ui.dateTo.val('');
      this.refuserpidView.setValue(false);
    },

    getRefuserpidText: function() {
      var deferred = new $.Deferred();
      App.request('kanban-tickets:get-users').done(_.bind(function (users) {
        var result = '';
        var text = [];
        _.each(users, _.bind(function (user) {
          if(this.userPidSecIds.indexOf(user.secId) !== -1)
            text.push(user.firstName.trim() + ' ' + user.lastName.trim());
        }, this));
        if(text.length > 0)
          result = text.join(', ');
        else
          result = _.i18n('notifications.to', 'Notification to');

        deferred.resolve(result);
      }, this));

      return deferred;
    }


  });
});

